import { WebSocketAction } from "../middlewares/wsMiddleware";

export const MONITOR_WS_CONNECTION_START = 'MONITOR_WS_CONNECTION_START';
export const MONITOR_WS_CONNECTION_SUCCESS = 'MONITOR_WS_CONNECTION_SUCCESS';
export const MONITOR_WS_CONNECTION_ERROR = 'MONITOR_WS_CONNECTION_ERROR';
export const MONITOR_WS_CONNECTION_CLOSED = 'MONITOR_WS_CONNECTION_CLOSED';
export const MONITOR_WS_GET_MESSAGE = 'MONITOR_WS_GET_MESSAGE';
export const MONITOR_WS_SEND_MESSAGE = 'MONITOR_WS_SEND_MESSAGE';

export interface IMonitorWsConnectionStartAction extends WebSocketAction {
    readonly type: typeof MONITOR_WS_CONNECTION_START;
}

export interface IMonitorWsConnectionSuccessAction extends WebSocketAction {
    readonly type: typeof MONITOR_WS_CONNECTION_SUCCESS;
}

export interface IMonitorWsConnectionErrorAction extends WebSocketAction {
    readonly type: typeof MONITOR_WS_CONNECTION_ERROR;
    readonly payload: string;
}

export interface IMonitorWsConnectionClosedAction extends WebSocketAction {
    readonly type: typeof MONITOR_WS_CONNECTION_CLOSED;
    readonly payload: string;
}

export interface IMonitorWsGetMessageAction extends WebSocketAction {
    readonly type: typeof MONITOR_WS_GET_MESSAGE;
    readonly payload: string;
}

export interface IMonitorWsSendMessageAction extends WebSocketAction {
    readonly type: typeof MONITOR_WS_SEND_MESSAGE;
    readonly payload: string;
}

export type TMonitorWsActions =
    IMonitorWsConnectionStartAction |
    IMonitorWsConnectionSuccessAction |
    IMonitorWsConnectionErrorAction |
    IMonitorWsConnectionClosedAction |
    IMonitorWsGetMessageAction |
    IMonitorWsSendMessageAction;

export const monitorWsConnectionStart = (): IMonitorWsConnectionStartAction => ({ type: MONITOR_WS_CONNECTION_START });

export const monitorWsConnectionSuccess = (): IMonitorWsConnectionSuccessAction => ({ type: MONITOR_WS_CONNECTION_SUCCESS });

export const monitorWsConnectionError = (payload: string): IMonitorWsConnectionErrorAction => ({ type: MONITOR_WS_CONNECTION_ERROR, payload: payload });

export const monitorWsConnectionClosed = (payload: string): IMonitorWsConnectionClosedAction => ({ type: MONITOR_WS_CONNECTION_CLOSED, payload: payload });

export const monitorWsGetMessage = (message: string): IMonitorWsGetMessageAction => ({ type: MONITOR_WS_GET_MESSAGE, payload: message });

export const monitorWsSendMessage = (message: string): IMonitorWsSendMessageAction => ({ type: MONITOR_WS_SEND_MESSAGE, payload: message });